// extracted by mini-css-extract-plugin
export var borderless = "TableHeading-module--borderless--fe5ab";
export var centered = "TableHeading-module--centered--86bf5";
export var container = "TableHeading-module--container--330a3";
export var sortIcon = "TableHeading-module--sortIcon--5397c";
export var sortable = "TableHeading-module--sortable--b8ffd";